import CryptoJS from 'crypto-js';
import forge from 'node-forge';
import LZString from 'lz-string';

const ENCRYPTION_KEY = import.meta.env.VITE_ENCRYPTION_KEY;
const PUBLIC_KEY = import.meta.env.VITE_PUBLIC_KEY;

// Separate encryption key for special rights
const RIGHTS_ENCRYPTION_KEY = 'YourSpecialRightsEncryptionKey'; // You should move this to env variables

export const encrypt = (plainText, PUBLIC_KEY) => {
    try {
        // Decode the raw base64 public key
        const derBuffer = forge.util.decode64(PUBLIC_KEY);
        const asn1 = forge.asn1.fromDer(derBuffer);
        const publicKey = forge.pki.publicKeyFromAsn1(asn1);

        const encrypted = publicKey.encrypt(plainText, 'RSAES-PKCS1-V1_5');

        const encryptedData = forge.util.encode64(encrypted);

        return encryptedData;
    } catch (error) {
        console.error('Encryption error:', error);
    }
};

export const encryptData = (data) => {
    try {
        const keyWords = CryptoJS.enc.Base64.parse(ENCRYPTION_KEY);
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), keyWords, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    } catch (error) {
        console.error('Encryption error:', error);
        throw error;
    }
};

export const decryptData = (encryptedData) => {
    try {
        const keyWords = CryptoJS.enc.Base64.parse(ENCRYPTION_KEY);
        const bytes = CryptoJS.AES.decrypt(encryptedData, keyWords, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (error) {
        console.error('Decryption error:', error);
        return [];
    }
};

export const encryptSpecialRights = (rights) => {
    try {
        
        // Convert rights to string and compress to minimize size
        const rightsString = JSON.stringify(rights);
        const compressed = LZString.compressToBase64(rightsString);
        
        // Encrypt using the same key and method as other data
        const keyWords = CryptoJS.enc.Base64.parse(ENCRYPTION_KEY); // Use the same key as other data
        const encrypted = CryptoJS.AES.encrypt(compressed, keyWords, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        
        return encrypted.toString();
    } catch (error) {
        console.error('Special rights encryption error:', error);
        return null;
    }
};

export const decryptSpecialRights = (encryptedRights) => {
    if (!encryptedRights) {
        return [];
    }

    try {
        // Decrypt using the same key and method as other data
        const keyWords = CryptoJS.enc.Base64.parse(ENCRYPTION_KEY);
        const decrypted = CryptoJS.AES.decrypt(encryptedRights, keyWords, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        
        const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8);
        const decompressed = LZString.decompressFromBase64(decryptedStr);
        
        return JSON.parse(decompressed);
    } catch (error) {
        console.error('Special rights decryption error:', error);
        return [];
    }
};

// No need for getEncryptionKey anymore since we're using a fixed key 